type Props = {
  title: string
  subtitle?: string
  onClick?: () => void
}

export const HistoricoItemCard = ({ title, subtitle, onClick }: Props) => (
  <div
    className='bg-white cursor-pointer border rounded p-3 h-100
    d-flex flex-column justify-content-between
    transition
    hover-elevate-up'
    onClick={onClick}
  >
    <div className='fw-bold fs-7 text-gray-800 text-break'>{title}</div>

    <div className='text-muted fs-8 mt-2'>{subtitle}</div>
  </div>
)
